import { appBaseName } from '../constants';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/actionCreators';

import Featured from './Featured';
import MobileSidebarCard from './MobileSidebarCard';
import MobileMenuToggle from './MobileMenuToggle';
import SeverityLevel from './SeverityLevel';
import Tooltip from './Tooltip';
import SkyscannerBanner from './SkyscannerBanner';
import Disclaimer from './Disclaimer';

class Travel extends React.Component {
	constructor() {
		super();
		this.scrollContainer = React.createRef();
		this.getFeatured = this.getFeatured.bind(this);
	}

	// componentWillMount(){
	// 	for ( let country of this.props.data ) {
	// 		console.log(country);
	// 	}
	// }

	componentWillReceiveProps(nextProps) {
		if (nextProps.pathname !== '/travel') {
			// close mobile sidebar cards
			this.MobileSidebarCard.closeMobileCard();
		}
	}

	getFeatured() {
		if (this.props.data) {
			return this.props.data.filter((country) => {
				return country.hasOwnProperty('topDestination');
			});
		}
		return this.props.data;
	}

	renderFeatured() {
		const featured = this.getFeatured();
		if (featured) {
			const sortedFeatured = featured.sort((a, b) => {
				return a.topDestination - b.topDestination;
			});
			return (
				<div className="featured-list">
					{sortedFeatured.map((f, i) => (
						<Featured key={i} country={f} />
					))}
				</div>
			);
		}
		return null;
	}

	render() {
		return (
			<div className="content-container">
				<MobileSidebarCard
					ref={(MobileSidebarCard) => {
						this.MobileSidebarCard = MobileSidebarCard;
					}}
				>
					<div className="mobile-header">
						<div className="intro">
							<div className="intro-title">
								{window.vaxihub ? (
									<div>
										<a href="/" className="icon icon-vaccine-hub-logo hide-md" />
										<h1 className="priority-2 no-margin">
											<span className="hide-md">Travel Map</span>
											<span className="show-md">
												<span className="icon icon-star" />
												Top Destinations
											</span>
										</h1>
									</div>
								) : (
									<h1 className="priority-2 no-margin">
										<span className="icon icon-star show-md" />
										Top Destinations
									</h1>
								)}
							</div>
						</div>
					</div>

					<div className="mobile-scrollable" ref={(ref) => (this.scrollContainer = ref)}>
						<div className="mobile-scrollable-content">
							<div className="sidebar-section">
								<div className="intro-prompt">
									<div>View official travel advice and vaccine recommendations</div>
								</div>
							</div>

							<div className="sidebar-section">
								<div className="legend">
									<div className="legend__title">
										<span>Travel Advice by Smartraveller</span>
										<Tooltip scrollContainer={this.scrollContainer}>
											This official travel advice is taken from the Smartraveller.gov.au website. For the latest and
											most complete information, please visit{' '}
											<a
												target="_blank"
												rel="noopener noreferrer"
												href="https://smartraveller.gov.au"
												data-lightbox="leavesite"
											>
												Smartraveller.gov.au
											</a>
										</Tooltip>
									</div>
									<div className="legend__items">
										<div className="legend__column">
											<SeverityLevel level={4} />
											<SeverityLevel level={3} />
											<SeverityLevel level={0} />
										</div>
										<div className="legend__column">
											<SeverityLevel level={2} />
											<SeverityLevel level={1} />
										</div>
									</div>
								</div>
							</div>

							{window.vaxihub && (
								<div className="sidebar-section">
									<div className="intro-prompt">
										<div className="heading-label hide-md">Top Destinations</div>
									</div>
								</div>
							)}

							{this.renderFeatured()}

							{window.vaxihub && (
								<div className="find-a-doctor sidebar-section">
									<div className="find-a-doctor-inner">
										<p>
											Vaccine Hub offers general information only. Please see a healthcare professional for medical
											advice.
										</p>
										<p>
											<a href="/?findADoctor=1" className="arrow-link">
												Find a doctor near you
												<span className="arrow" />
											</a>
										</p>
									</div>
								</div>
							)}

							<Disclaimer hideSeparator={window.vaxiplace} />
						</div>
					</div>

					<div className="mobile-footer">
						<button
							className="button button-grey button-block mobile-footer-btn"
							onClick={() => this.MobileSidebarCard.closeMobileCard()}
						>
							Back to map
						</button>
					</div>
				</MobileSidebarCard>
				<MobileMenuToggle
					className="travel-toggle"
					text="Top Destinations"
					onClick={() => this.MobileSidebarCard.openMobileCard()}
				/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		data: state.json.data.travel,
		pathname: state.routing.location.pathname,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Travel);
